/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { trackPromise } from "react-promise-tracker";
import { PersonalChangeRequestsByMember } from "../../../../../@types/changeRequests.types";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../contexts";
import useRouteParam from "../../../../../hooks/useRouteParam";
import { api } from "../../../../../utils/api";
import PersonalChangeRequestGrid from "./personalChangeRequestGrid/PersonalChangeRequestGrid";

const PersonalChangeRequest = () => {
	const [personalChangeRequests, setPersonalChangeRequests] = useState<PersonalChangeRequestsByMember[]>([]);
	const { setDashboardHeader } = useContext(UIContext);
	const queryGroupNumber = useRouteParam("gn");

	const getPersonalChangeRequests = useCallback(async () => {
		if (!queryGroupNumber) {
			return;
		}

		const personalChangeRequestQuery = {
			group_number: queryGroupNumber
		};
		const _personalChangeRequests: PersonalChangeRequestsByMember[] = await trackPromise(
			api.changeRequest.getPersonalChangeRequests(personalChangeRequestQuery)
		);
		setPersonalChangeRequests(Object.assign([], _personalChangeRequests));
	}, [queryGroupNumber]);

	useEffect(() => {
		if (queryGroupNumber) {
			getPersonalChangeRequests();
		}
	}, [getPersonalChangeRequests, queryGroupNumber]);

	useEffect(() => {
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.employer_personal_change_request);
	}, [setDashboardHeader]);

	return (
		<div className="personal-change-request-container">
			<PersonalChangeRequestGrid personalChangeRequests={personalChangeRequests} />
		</div>
	);
};

export default PersonalChangeRequest;
